<template>
<div>
  <el-form-item label="AI角色">
    <el-input v-model="form.ai_role"></el-input>
  </el-form-item>
  <el-form-item label="用户角色">
    <el-input v-model="form.user_role"></el-input>
  </el-form-item>
  <el-form-item label="AI预设 (设置AI背景信息，用户不可见)">
    <el-input v-model="form.ai_preset" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
  </el-form-item>
  <el-form-item label="用户预设 (以AI身份发给用户的内容, 此内容会插入到进入消息模板的{user_preset}处)">
    <el-input v-model="form.user_preset" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
  </el-form-item>
  <el-form-item label="用户任务 (用户要完成的任务)">
    <el-input v-model="form.user_task" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
  </el-form-item>
</div>
</template>

<script>
export default {
  name: "ai_rpg_form",
  props: {
    form: Object
  }
}
</script>